import { IFlightItem } from "@/components/FlightRow/FlightRow";
import { atom } from "recoil";

const FlightByDestinationListAtom = atom<null | IFlightItem[]>({
    key: 'flightByDestinationList',
    default: null
})

export default FlightByDestinationListAtom;